<div class="form-check mb-0">
  <input class="form-check-input" 
         type="checkbox" 
         [(ngModel)]="selected" 
         [id]="'letter-' + details.id">
  <label class="form-check-label" [for]="'letter-' + details.id">
    {{details.fileName}}
  </label>
</div>